function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
const colors = {
  green: '#daf0ed',
  pink: '#f9c3c7'
};
const SvgComponent = /*#__PURE__*/forwardRef(({
  color,
  width,
  height,
  size,
  ...rest
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  viewBox: "0 0 34 34",
  width: size || width,
  height: size || height
}, rest), /*#__PURE__*/React.createElement("path", {
  d: "M30.1 5.543c-.2-.64-1.12-.48-1.62-.48-.93 0-1.86-.01-2.79-.01-5.44-.03-10.89-.02-16.34-.03-1.51 0-3.03 0-4.55.01a.616.616 0 00-.63.55.642.642 0 00-.04.44c1.89 7.51 1.88 14.87-1.18 22.1a.72.72 0 00.61 1.07q12.225-.075 24.43-.23c1.08-.01 1.78-3.48 2.01-4.21a33.989 33.989 0 001.29-6.39 32.681 32.681 0 00-1.19-12.82zm-1.05.72a25.98 25.98 0 011.07 6.05c-7.65.05-16.02.13-23.25.16a27.609 27.609 0 00-1.22-6.1c7.296-.06 15.736-.06 23.396-.11zm-1.7 21.37c-.02.03-.01.05-.02.08q-11.37 0-22.73.06a34.748 34.748 0 002.36-13.96c7.22-.05 15.57-.26 23.2-.31a33.088 33.088 0 01-2.814 14.13z",
  fill: "#828a90"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.116 12.313c-7.65.05-16.02.13-23.25.16a27.609 27.609 0 00-1.22-6.1c7.3-.06 15.74-.06 23.4-.11a25.98 25.98 0 011.07 6.05z",
  fill: colors[color]
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.346 27.633c-.02.03-.01.05-.02.08q-11.37 0-22.73.06a34.748 34.748 0 002.36-13.96c7.22-.05 15.57-.26 23.2-.31a33.088 33.088 0 01-2.81 14.13z",
  fill: "#fff"
})));
SvgComponent.defaultProps = {
  color: 'pink',
  height: 34,
  width: 34
};
SvgComponent.propTypes = {
  color: PropTypes.oneOf(['green', 'pink']),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SvgComponent;